<script>
import { mapActions } from "vuex";

export default {
  data: function () {
    return {
      maxCount: 10,
      series: [],
      chartOptions: {
        labels: [],
        labels_data: [
          "SDG 1",
          "SDG 2",
          "SDG 3",
          "SDG 4",
          "SDG 5",
          "SDG 6",
          "SDG 7",
          "SDG 8",
          "SDG 9",
          "SDG 10",
          "SDG 11",
          "SDG 12",
          "SDG 13",
          "SDG 14",
          "SDG 15",
          "SDG 16",
          "SDG 17",
        ],
        chart: {
          type: "polarArea",
          toolbar: {
            show: false,
          },
        },
        colors: [
          "#E6243C",
          "#D19F2A",
          "#2D9A47",
          "#C22033",
          "#EF412A",
          "#00ADD8",
          "#FDB714",
          "#8F1838",
          "#F36E24",
          "#E01A83",
          "#F99D25",
          "#CD8B2A",
          "#48773C",
          "#007DBB",
          "#40AE49",
          "#00558A",
          "#1A3668",
        ],
        dataLabels: {
          enabled: false,
          formatter: function (value, { seriesIndex, w }) {
            return (
              w.config.labels_data[seriesIndex] +
              ": " +
              w.config.series[seriesIndex]
            );
          },
        },
        legend: {
          show: false,
          position: "right",
          offsetX: -50,
          fontSize: "12px",
          fontWeight: "bold",
          fontFamily: "Roboto",
          color: "#263238",
        },
        stroke: {
          colors: ["#fff"],
        },
        fill: {
          opacity: 0.95,
        },
        yaxis: {
          labels: {
            formatter: (value) => {
              return value.toFixed(1);
            },
          },
          show: false,
          max: this.maxCount,
        },
      },
    };
  },

  created() {
    this.getGlobalForPie();
  },
  props: {
    selectedSurveyID: null,
  },
  methods: {
    ...mapActions("results", ["su1Pie"]),
    getGlobalForPie() {
      let params = {
        company_id: this.$user.company_id,
        is_deleted: false,
        su1_survey_id: this.selectedSurveyID,
      };
      this.su1Pie(params)
        .then((response) => {
          response.data.globalGoalsSelectionCounts.forEach((item) => {
            this.series.push(item.selectionCount),
              this.chartOptions.labels.push("SDG " + item.globalGoalName);
            this.maxCount = Math.max(...this.series);
          });
        })
        .catch(({ response }) => {
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        });
    },
  },
};
</script>

<template>
  <apex-chart type="polarArea" :options="chartOptions" :series="series" width="100%"></apex-chart>
</template>

<style>
.apexcharts-legend {
  justify-content: center !important;
}
</style>